import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingBetslips: false,
  betslips: [],
  nextCursor: null,
  hasMore: false,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_BET_SLIPS: (s, data) => (s.loadingBetslips = data),
    SET_BET_SLIPS: (s, data) => {
      s.betslips = data.betslips;
      s.nextCursor = data.nextCursor;
      s.hasMore = data.hasMore;
    },
    APPEND_BET_SLIPS: (s, data) => {
      s.betslips = [...s.betslips, ...data.betslips];
      s.nextCursor = data.nextCursor;
      s.hasMore = data.hasMore;
    },
  },

  actions: {
    async getBetslips({ commit }, params) {
      commit("LOAD_BET_SLIPS", true);
      try {
        const res = await this.$api.get("/v1/portal/betslips", { params });
        const { data, metadata } = res.data;
        commit("SET_BET_SLIPS", {
          betslips: data || [],
          nextCursor: metadata?.nextCursor || null,
          hasMore: metadata?.hasMore || false,
        });
        return data || [];
      } catch (e) {
        errorHandler(e);
        return [];
      } finally {
        commit("LOAD_BET_SLIPS", false);
      }
    },
    async getAllBetslipsForExport({ commit }, params) {
      const baseParams = { ...params, limit: 500 };
      let all = [];
      let cursor = null;
      let hasMore = true;
      while (hasMore) {
        const reqParams = cursor ? { ...baseParams, cursor } : baseParams;
        const res = await this.$api.get("/v1/portal/betslips", { params: reqParams });
        const { data, metadata } = res.data;
        all = [...all, ...(data || [])];
        cursor = metadata?.nextCursor || null;
        hasMore = !!(metadata?.hasMore);
      }
      return all;
    },
    async loadMoreBetslips({ commit, state }, params) {
      if (state.loadingBetslips || !state.hasMore) return [];
      commit("LOAD_BET_SLIPS", true);
      try {
        const res = await this.$api.get("/v1/portal/betslips", {
          params: { ...params, cursor: state.nextCursor },
        });
        const { data, metadata } = res.data;
        commit("APPEND_BET_SLIPS", {
          betslips: data || [],
          nextCursor: metadata?.nextCursor || null,
          hasMore: metadata?.hasMore || false,
        });
        return data || [];
      } catch (e) {
        errorHandler(e);
        return [];
      } finally {
        commit("LOAD_BET_SLIPS", false);
      }
    },
  },
};
